import { SCORING, comboMult } from './config';

// Pure scoring helpers — no state, no randomness. Integer points throughout.

/** Points for eating a correct cell at the given (already-incremented) combo. */
export function scoreCorrect(combo: number): number {
  return Math.round(SCORING.correctBase * comboMult(combo));
}

/** Apply the Gauntlet multiplier to a base correct score (a "threaded" fenced answer). */
export function gauntletScore(base: number): number {
  return Math.round(base * SCORING.gauntletMult);
}

/** Did the player thread enough armed decoys to earn the Gauntlet bonus? */
export function isGauntlet(armedTraversals: number): boolean {
  return armedTraversals >= SCORING.gauntletArmThreshold;
}

export { comboMult };
